import JSZip from "jszip";

export async function downloadFiles(urls: string[], title: string, format: string): Promise<void> {
  if (urls.length === 1) {
    void downloadFile(urls[0]!, title, format);
  } else {
    const zip = new JSZip();

    await Promise.all(
      urls.map(async (url, index) => {
        const response = await fetch(url);
        const blob = await response.blob();

        const name = `${title} (${index + 1}).${format}`;

        zip.file(name, blob);
      }),
    );

    const zipBlob = await zip.generateAsync({ type: "blob" });
    saveBlob(zipBlob, `${title}.zip`);
  }
}

export const downloadFile = async (url: string, title: string, format: string): Promise<void> => {
  const file = await fetch(url);

  saveBlob(await file.blob(), `${title}.${format}`);
};

function saveBlob(blob: Blob, fileName: string): void {
  const downloadUrl = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = downloadUrl;
  a.download = fileName;
  a.click();

  setTimeout(() => URL.revokeObjectURL(downloadUrl), 1000);
}
